// @material-ui/core
import {
  Card,
  CardContent,
  CardHeader,
  Grid,
  TextField,
  Typography
} from "@material-ui/core";
import React, { Component } from "react";
import { withRouter } from "react-router";
import MainButton from "../../library/button/MainButton";
import Caba from "../../services/Caba";

class AppEdit extends Component {
  state = {
    app: {
      id: "",
      name: "",
      clientId: "",
      trialDuration: 0
    }
  };

  componentDidMount() {
    this.props.toggleLoading(true);

    // make a call
    Caba.get("/api/v1/apps/" + this.props.match.params.id).then(response => {
      this.props.toggleLoading(false);
      this.setState({
        app: response.data
      });
    });
  }

  handleChange = name => event => {
    this.setState({
      app: { ...this.state.app, [name]: event.target.value }
    });
  };

  handleClick = event => {
    Caba.put("/api/v1/apps/" + this.props.match.params.id, this.state.app).then(
      response => {
        if (response.status === 200) {
          this.props.notify("success", "200", "Saved");
          this.props.history.push(
            "/apps/" + this.props.match.params.id + "/view"
          );
        }
      }
    );
  };

  render() {
    const { app } = this.state;

    return (
      <Card>
        <CardHeader title={this.state.app.name} />
        <CardContent>
          <Grid container>
            <Grid item xs={12}>
              <Typography type="subheading">
                <small>App</small>
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={12}>
                  <Typography type="subheading">
                    <small>Name</small>
                  </Typography>
                  <TextField
                    id="name"
                    value={app.name ? app.name : ""}
                    onChange={this.handleChange("name")}
                    margin="dense"
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography type="subheading">
                    <small>ID</small>
                  </Typography>
                  <TextField
                    id="id"
                    value={app.id ? app.id : ""}
                    onChange={this.handleChange("id")}
                    margin="dense"
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography type="subheading">
                    <small>Client ID</small>
                  </Typography>
                  <TextField
                    id="clientId"
                    value={app.clientId ? app.clientId : ""}
                    onChange={this.handleChange("clientId")}
                    margin="dense"
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography type="subheading">
                    <small>Trial Duration</small>
                  </Typography>
                  <TextField
                    id="trialDuration"
                    value={app.trialDuration ? app.trialDuration : ""}
                    onChange={this.handleChange("trialDuration")}
                    margin="dense"
                    fullWidth
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <MainButton
                onClick={event => this.handleClick(event)}
                raised
                fullWidth
                colored="blue">
                Save
              </MainButton>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  }
}

export default withRouter(AppEdit);



// WEBPACK FOOTER //
// ./src/pages/apps/AppEdit.js